export { PrivacyPolicyFooter } from "./PrivacyPolicyFooter"
